import React, { useState } from 'react';
import FadeIn from './ui/FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown } from 'react-icons/fi';

const faqs = [
  {
    q: "Do you ship nationwide?",
    a: "Yes! We ship via UPS anywhere in the United States. Shipping rates are flat per box based on your region."
  },
  {
    q: "What's the minimum order?",
    a: "Our minimum order is just 4 vases. Vases are packaged and shipped in safe boxes of 4."
  },
  {
    q: "Can I mix designs in one order?",
    a: "Absolutely. You can select different designs for your order as long as the total quantity meets the minimums."
  },
  {
    q: "Do you offer tax-exempt pricing?",
    a: "Yes, we offer tax-exempt ordering for resellers. You can submit your reseller certificate during the onboarding process."
  },
  {
    q: "How long does delivery take?",
    a: "Local West Valley deliveries are typically fulfilled within 2-3 business days. Nationwide shipping depends on UPS ground times from Arizona."
  },
  {
    q: "Can I see the designs before ordering?",
    a: "Yes! Creating an account on our order portal gives you full access to browse our extensive design library."
  }
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="py-24 bg-warmWhite">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl">
        <FadeIn className="text-center mb-16">
          <h2 className="font-heading text-4xl font-bold">Frequently Asked Questions</h2>
        </FadeIn>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <FadeIn key={idx} delay={idx * 0.05}>
              <div 
                className="bg-white rounded-xl border border-gray-100 overflow-hidden cursor-pointer transition-all hover:border-blush/30"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <div className="px-6 py-5 flex justify-between items-center">
                  <h4 className="font-semibold text-charcoal">{faq.q}</h4>
                  <SafeIcon 
                    icon={FiChevronDown} 
                    className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} 
                  />
                </div>
                <div 
                  className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <p className="text-gray-500 font-light">{faq.a}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}